import { jsx as _jsx } from "react/jsx-runtime";
import { tv } from "tailwind-variants";
import cn from "../../../utils/cn";
const dropdownMenuIconVariants = tv({
    base: "mr-1 flex flex-row items-center justify-center  [&>svg]:w-4 [&>svg]:h-4 [&>svg]:text-gray-10 group-hover:[&>svg]:text-gray-11",
    variants: {
        type: {
            contained: "rounded-md bg-gray-3 ",
            ghost: "",
        },
    },
    defaultVariants: {
        type: "ghost",
    },
});
const DropdownMenuIcon = ({ icon, type, className }) => {
    return _jsx("div", { className: cn(dropdownMenuIconVariants({ type }), className), children: icon });
};
export default DropdownMenuIcon;
